(function () {
  'use strict';

  var MENU_URL = '/pages/locations';
  /* Built per call, not once at load: the locale follows the active Weglot language,
     which may not be resolved yet when this file runs. See assets/checkout-locale.js. */
  function checkoutUrl() {
    var locale = window.igoCheckoutLocale ? window.igoCheckoutLocale() : 'en-AU';
    return '/checkout?locale=' + locale + '&method=delivery&skip_shopify_pay=true&step=contact_information';
  }
  var ZAPIET_SHOP = 'inspiredgo.myshopify.com';
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DATE_ATTRIBUTE_KEYS = ['Delivery-Date', 'delivery_date', 'selected_delivery_date'];
  var POSTAL_ATTRIBUTE_KEYS = ['Postal-Input', 'Delivery-Postal-Code', 'postal', 'zip'];

  var REGION_LOCATION_IDS = {
    'toronto': ['242677', '270213', '285794', '289774', '252149', '285777'],
    'quebec':   ['319959'],
    'usa-west': ['273216', '276649', '277960', '278438', '279269', '288292', '299051', '301750'],
    'usa-east': ['301948', '310459', '310466'],
    'calgary': ['137796', '137798', '270994', '270576']
  };

  var REGION_ALIASES = {
    east: 'toronto',
    ca_on: 'toronto',
    ca_qc: 'toronto',
    ontario: 'toronto',
    // Quebec has its own menu but shares the Toronto delivery schedule
    quebec: 'toronto',
    montreal: 'toronto',
    'usa east': 'usa-east',
    usaeast: 'usa-east',
    us_east: 'usa-east',
    'usa west': 'usa-west',
    usawest: 'usa-west',
    us_west: 'usa-west',
    west: 'calgary',
    alberta: 'calgary'
  };

  var REGION_SCHEDULES = {
    // Fallback schedule used when Zapiet calendar data is unavailable.
    // Keep region-specific cutoff and buffer rules here until they can be shared from one source of truth.
    calgary: {
      timeZone: 'Etc/GMT+6',
      cutoff: '22:00',
      routes: [
        { orderBy: 3, deliverOn: 5 },
        { orderBy: 4, deliverOn: 0 },
        { orderBy: 5, deliverOn: 1 }
      ]
    },
    toronto: {
      timeZone: 'America/Toronto',
      cutoff: '22:30',
      routes: [
        { orderBy: 3, deliverOn: 0 },
        { orderBy: 4, deliverOn: 1 }
      ]
    },
    'usa-west': {
      timeZone: 'America/Los_Angeles',
      cutoff: '20:00',
      routes: [
        { orderBy: 3, deliverOn: 0 },
        { orderBy: 4, deliverOn: 1 }
      ]
    },
    'usa-east': {
      timeZone: 'America/New_York',
      cutoff: '22:30',
      routes: [
        { orderBy: 3, deliverOn: 0 },
        { orderBy: 4, deliverOn: 1 }
      ]
    }
  };

  var recoveryContext = null;

  function pushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function getUi() {
    return {
      root: document.querySelector('[data-recover-cart]'),
      title: document.querySelector('[data-recover-title]'),
      message: document.querySelector('[data-recover-message]'),
      date: document.querySelector('[data-recover-date]'),
      actions: document.querySelector('[data-recover-actions]'),
      button: document.querySelector('[data-recover-button]'),
      secondary: document.querySelector('[data-recover-secondary]'),
      calendar: document.querySelector('[data-recover-calendar]'),
      dateGrid: document.querySelector('[data-recover-date-grid]'),
      status: document.querySelector('[data-recover-status]')
    };
  }

  function hideCalendar(ui) {
    if (ui.calendar) ui.calendar.hidden = true;
    if (ui.status) ui.status.textContent = '';
  }

  function setState(ui, state, title, message, options) {
    options = options || {};
    if (!ui.root) return;

    ui.root.classList.remove('is-loading', 'is-ready', 'is-failed', 'is-location');
    ui.root.classList.add('is-' + state);
    if (ui.title) ui.title.textContent = title;
    if (ui.message) ui.message.textContent = message || '';

    if (ui.date) {
      if (options.dateText) {
        ui.date.textContent = options.dateText;
        ui.date.hidden = false;
      } else {
        ui.date.hidden = true;
      }
    }

    if (ui.actions) ui.actions.hidden = !options.primaryText && !options.secondaryText;

    if (ui.button) {
      if (options.primaryText) {
        ui.button.textContent = options.primaryText;
        ui.button.href = options.primaryUrl || '#';
        ui.button.hidden = false;
      } else {
        ui.button.hidden = true;
      }
    }

    if (ui.secondary) {
      if (options.secondaryText) {
        ui.secondary.textContent = options.secondaryText;
        ui.secondary.hidden = false;
      } else {
        ui.secondary.hidden = true;
      }
    }

    if (!options.keepCalendarOpen) hideCalendar(ui);
  }

  function normalizeRegion(region) {
    var value = String(region || '').trim().toLowerCase();
    return REGION_ALIASES[value] || value || '';
  }

  function regionFromLocationId(locationId) {
    var id = String(locationId || '');
    var regions = Object.keys(REGION_LOCATION_IDS);
    for (var i = 0; i < regions.length; i++) {
      if (REGION_LOCATION_IDS[regions[i]].indexOf(id) !== -1) return regions[i];
    }
    return '';
  }

  function parseLocalDate(value) {
    if (!value) return null;
    var raw = String(value).trim();
    var match = raw.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);
    if (!match) return null;
    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
    return date;
  }

  function formatDate(date, separator) {
    var sep = separator || '-';
    return date.getFullYear() + sep +
      String(date.getMonth() + 1).padStart(2, '0') + sep +
      String(date.getDate()).padStart(2, '0');
  }

  function formatDisplayDate(dateString) {
    var date = parseLocalDate(dateString);
    if (!date) return dateString || '';
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    });
  }

  function startOfZonedDay(date, timeZone) {
    var parts = getTimePartsInZone(date, timeZone);
    return new Date(parts.year, parts.month - 1, parts.day);
  }

  function addDays(date, days) {
    var next = new Date(date.getTime());
    next.setDate(next.getDate() + days);
    return next;
  }

  function getTimePartsInZone(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      weekday: 'short'
    });
    var parts = formatter.formatToParts(date).reduce(function (acc, part) {
      acc[part.type] = part.value;
      return acc;
    }, {});
    var weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour: Number(parts.hour === '24' ? '0' : parts.hour),
      minute: Number(parts.minute),
      second: Number(parts.second),
      weekday: weekdayMap[parts.weekday]
    };
  }

  function zonedDateKey(date, timeZone) {
    var parts = getTimePartsInZone(date, timeZone);
    return parts.year + '-' + String(parts.month).padStart(2, '0') + '-' + String(parts.day).padStart(2, '0');
  }

  function isRouteStillOpenForDate(deliveryDate, route, schedule, now) {
    var nowParts = getTimePartsInZone(now, schedule.timeZone);
    var daysFromOrderToDeliver = (route.deliverOn - route.orderBy + 7) % 7;
    var orderDate = addDays(deliveryDate, -daysFromOrderToDeliver);
    var orderKey = formatDate(orderDate);
    var todayKey = zonedDateKey(now, schedule.timeZone);

    if (orderKey < todayKey) return false;
    if (orderKey > todayKey) return true;

    var cutoff = schedule.cutoff.split(':').map(Number);
    var cutoffMinutes = cutoff[0] * 60 + cutoff[1];
    var nowMinutes = nowParts.hour * 60 + nowParts.minute;
    return nowMinutes <= cutoffMinutes;
  }

  function isServiceableDate(deliveryDate, schedule, now) {
    if (formatDate(deliveryDate) < zonedDateKey(now, schedule.timeZone)) return false;

    for (var i = 0; i < schedule.routes.length; i++) {
      var route = schedule.routes[i];
      if (deliveryDate.getDay() === route.deliverOn && isRouteStillOpenForDate(deliveryDate, route, schedule, now)) {
        return true;
      }
    }

    return false;
  }

  function getNextAvailableDeliveryDate(options) {
    var region = normalizeRegion(options && options.region) || 'calgary';
    var schedule = REGION_SCHEDULES[region] || REGION_SCHEDULES.calgary;
    var currentDate = options && options.currentDate ? options.currentDate : new Date();
    var start = startOfZonedDay(currentDate, schedule.timeZone);

    for (var i = 0; i <= 35; i++) {
      var candidate = addDays(start, i);
      if (isServiceableDate(candidate, schedule, currentDate)) {
        return formatDate(candidate);
      }
    }

    return formatDate(addDays(start, 1));
  }

  function validateDeliveryDate(options) {
    var region = normalizeRegion(options.region) || 'calgary';
    var schedule = REGION_SCHEDULES[region] || REGION_SCHEDULES.calgary;
    var parsed = parseLocalDate(options.deliveryDate);
    var nextAvailableDate = getNextAvailableDeliveryDate({
      region: region,
      postalCode: options.postalCode,
      currentDate: options.now
    });

    return {
      isValid: !!parsed && isServiceableDate(parsed, schedule, options.now),
      nextAvailableDate: nextAvailableDate
    };
  }

  function getFallbackAvailableDates(region, currentDate) {
    var dates = [];
    var date = parseLocalDate(getNextAvailableDeliveryDate({
      region: region,
      currentDate: currentDate || new Date()
    }));
    var schedule = REGION_SCHEDULES[normalizeRegion(region)] || REGION_SCHEDULES.calgary;

    for (var i = 0; i <= 35 && dates.length < 10; i++) {
      var candidate = addDays(date, i);
      if (isServiceableDate(candidate, schedule, currentDate || new Date())) {
        dates.push(formatDate(candidate));
      }
    }

    return dates;
  }

  function getDatesFromZapietCalendar(calendarData) {
    var dates = [];
    if (!calendarData || !Array.isArray(calendarData.disabled)) return dates;

    if (calendarData.disabled[0] === true) {
      calendarData.disabled.slice(1).forEach(function (entry) {
        if (!Array.isArray(entry)) return;
        var date = new Date(entry[0], entry[1], entry[2]);
        dates.push(formatDate(date));
      });
    }

    return dates;
  }

  function getFirstValue(source, keys) {
    if (!source) return '';
    for (var i = 0; i < keys.length; i++) {
      if (source[keys[i]]) return source[keys[i]];
    }
    return '';
  }

  function parseNoteAttributes(note) {
    var attrs = {};
    String(note || '').split(/\n|,/).forEach(function (entry) {
      var parts = entry.split(/:|=/);
      if (parts.length < 2) return;
      var key = parts.shift().trim();
      var value = parts.join(':').trim();
      if (key && value) attrs[key] = value;
    });
    return attrs;
  }

  function getReliableDateFromCheckoutUrl(checkoutUrl) {
    if (!checkoutUrl) return '';
    try {
      var url = new URL(checkoutUrl, window.location.origin);
      var keys = DATE_ATTRIBUTE_KEYS.concat(['deliveryDate', 'date']);
      for (var i = 0; i < keys.length; i++) {
        var value = url.searchParams.get(keys[i]);
        if (parseLocalDate(value)) return value;
      }
    } catch (e) {}
    return '';
  }

  function getCheckoutUrl(params, options) {
    var allowOriginal = !options || options.allowOriginal !== false;
    var original = params.get('checkout_url');
    if (allowOriginal && original) {
      try {
        var url = new URL(original, window.location.origin);
        if (url.origin === window.location.origin && url.pathname.indexOf('/checkout') === 0) {
          return url.pathname + url.search + url.hash;
        }
      } catch (e) {}
    }

    return checkoutUrl();
  }

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart request failed');
      return res.json();
    });
  }

  function updateCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart update failed');
      return res.json();
    });
  }

  function getZapietCalendar(locationId, postalCode) {
    if (!locationId) return Promise.resolve(null);

    var body = new URLSearchParams();
    body.append('shop', ZAPIET_SHOP);
    if (postalCode) body.append('geoSearchQuery', postalCode);

    return fetch('https://api.zapiet.com/v1.0/delivery/locations/' + encodeURIComponent(locationId) + '/calendar?shop=' + ZAPIET_SHOP, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;' },
      body: body
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function buildDeliveryAttributes(context, dateString) {
    var date = parseLocalDate(dateString);
    var attrs = Object.assign({}, context.attrs, {
      'Delivery-Date': formatDate(date, '/'),
      'Delivery-Day': DAY_NAMES[date.getDay()],
      'Checkout-Method': 'delivery',
      delivery_date_auto_corrected: 'true',
      original_abandoned_delivery_date: context.originalDeliveryDate || '',
      abandoned_cart_recovered: 'true'
    });

    if (context.locationId) attrs['Delivery-Location-Id'] = String(context.locationId);
    delete attrs['Postal-Input'];
    if (context.attrs.delivery_date !== undefined) attrs.delivery_date = dateString;
    if (context.attrs.selected_delivery_date !== undefined) attrs.selected_delivery_date = dateString;

    return attrs;
  }

  function saveDeliveryDate(context, dateString) {
    var attrs = buildDeliveryAttributes(context, dateString);
    return updateCartAttributes(attrs).then(function (cart) {
      context.attrs = cart.attributes || attrs;
      context.selectedDate = dateString;
      return cart;
    });
  }

  function redirectToCheckout(params, options) {
    pushDataLayer({ event: 'abandoned_cart_recovery_redirect_checkout' });
    window.location.href = getCheckoutUrl(params, options);
  }

  function showRecoveryFailed(ui) {
    pushDataLayer({
      event: 'abandoned_cart_recovery_failed',
      reason: 'empty_cart'
    });
    setState(
      ui,
      'failed',
      'Your previous cart is no longer available.',
      'Please rebuild your order.',
      {
        primaryText: 'Start a new order',
        primaryUrl: MENU_URL
      }
    );
  }

  function showConfirmation(ui, context) {
    setState(
      ui,
      'ready',
      'Please confirm your delivery date.',
      'Your previous delivery date is no longer available, so we moved your order to the next available delivery date.',
      {
        dateText: formatDisplayDate(context.selectedDate),
        primaryText: 'Continue to checkout',
        primaryUrl: getCheckoutUrl(context.params, { allowOriginal: false }),
        secondaryText: 'Choose another date'
      }
    );
  }

  function renderDatePicker(ui, context) {
    var dates = (context.availableDates && context.availableDates.length)
      ? context.availableDates
      : getFallbackAvailableDates(context.region, new Date());

    if (!ui.calendar || !ui.dateGrid) return;

    ui.dateGrid.innerHTML = '';
    dates.slice(0, 12).forEach(function (dateString) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'recover-cart__date-option';
      button.textContent = formatDisplayDate(dateString);
      button.setAttribute('aria-pressed', dateString === context.selectedDate ? 'true' : 'false');
      button.addEventListener('click', function () {
        if (ui.status) ui.status.textContent = 'Updating your delivery date...';
        saveDeliveryDate(context, dateString)
          .then(function () {
            pushDataLayer({
              event: 'abandoned_cart_delivery_date_corrected',
              original_delivery_date: context.originalDeliveryDate || '',
              new_delivery_date: dateString
            });
            if (ui.status) ui.status.textContent = 'Delivery date updated.';
            showConfirmation(ui, context);
            bindConfirmationActions(ui, context);
          })
          .catch(function (err) {
            console.error('Recover cart date update error:', err);
            if (ui.status) ui.status.textContent = 'Something went wrong. Please try another date.';
          });
      });
      ui.dateGrid.appendChild(button);
    });

    ui.calendar.hidden = false;
  }

  function bindConfirmationActions(ui, context) {
    if (ui.button) {
      ui.button.onclick = function (event) {
        event.preventDefault();
        redirectToCheckout(context.params, { allowOriginal: false });
      };
    }

    if (ui.secondary) {
      ui.secondary.onclick = function () {
        setState(
          ui,
          'ready',
          'Choose your delivery date.',
          'Select another available delivery date before continuing to checkout.',
          {
            dateText: formatDisplayDate(context.selectedDate),
            primaryText: 'Continue to checkout',
            primaryUrl: getCheckoutUrl(context.params, { allowOriginal: false }),
            secondaryText: 'Hide dates',
            keepCalendarOpen: true
          }
        );
        ui.secondary.onclick = function () {
          showConfirmation(ui, context);
          bindConfirmationActions(ui, context);
        };
        renderDatePicker(ui, context);
      };
    }
  }

  function requestDeliveryLocation(ui) {
    setState(ui, 'location', 'Where should we deliver?', 'Enter your postal or ZIP code so we can show delivery dates for your area.');
    var form = document.querySelector('[data-recover-location]');
    var input = form.elements.postal;
    var button = form.querySelector('button');
    var status = document.getElementById('recover-location-status');
    form.hidden = false;
    input.focus();
    return new Promise(function (resolve) {
      form.onsubmit = function (event) {
        event.preventDefault();
        var postal = input.value.trim().toUpperCase();
        if (!postal) { input.focus(); return; }
        button.disabled = true;
        status.textContent = 'Checking your delivery area...';
        var body = new URLSearchParams();
        body.append('shop', ZAPIET_SHOP);
        body.append('geoSearchQuery', postal);
        fetch('https://api.zapiet.com/v1.0/delivery/locations?shop=' + ZAPIET_SHOP, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;' },
          body: body
        }).then(function (res) {
          if (!res.ok) throw new Error('Location lookup failed');
          return res.json();
        }).then(function (result) {
          var region = normalizeRegion(regionFromLocationId(result.id));
          if (result.error || !result.id || !REGION_SCHEDULES[region]) {
            status.textContent = 'We could not confirm delivery to that postal or ZIP code. Please check it and try again, or visit our locations page.';
            return;
          }
          form.hidden = true;
          form.onsubmit = null;
          setState(ui, 'loading', 'Checking your delivery dates...', 'We are checking availability for your delivery area.');
          resolve({ locationId: String(result.id), region: region, postalCode: postal, entered: true });
        }).catch(function () {
          status.textContent = 'We could not check your location right now. Please try again.';
        }).then(function () { button.disabled = false; });
      };
    });
  }

  function recoverAbandonedCart() {
    var ui = getUi();
    var params = new URLSearchParams(window.location.search || '');

    pushDataLayer({ event: 'abandoned_cart_recovery_started' });
    setState(ui, 'loading', 'Checking your order details...', 'We are making sure your delivery date is still available before checkout.');

    fetchCart()
      .then(function (cart) {
        if (!cart || !cart.item_count) {
          // TODO: If Klaviyo starts sending variant ID and quantity pairs, rebuild the cart via
          // /cart/VARIANT_ID:QUANTITY permalinks before showing this fallback.
          showRecoveryFailed(ui);
          return null;
        }

        var attrs = cart.attributes || {};
        var noteAttrs = parseNoteAttributes(cart.note);
        var locationId = params.get('location_id') || params.get('zapiet_location_id') || attrs['Delivery-Location-Id'];
        var region = normalizeRegion(regionFromLocationId(locationId));
        var postalCode = params.get('postal') || params.get('zip') || getFirstValue(attrs, POSTAL_ATTRIBUTE_KEYS);
        var locationReady = locationId && REGION_SCHEDULES[region]
          ? Promise.resolve({ locationId: locationId, region: region, postalCode: postalCode })
          : requestDeliveryLocation(ui);
        return locationReady.then(function (location) {
        locationId = location.locationId;
        region = location.region;
        postalCode = location.postalCode;
        attrs['Delivery-Location-Id'] = String(locationId);
        if (postalCode) attrs['Delivery-Postal-Code'] = postalCode;
        var currentDeliveryDate =
          params.get('delivery_date') ||
          getFirstValue(attrs, DATE_ATTRIBUTE_KEYS) ||
          getFirstValue(noteAttrs, DATE_ATTRIBUTE_KEYS) ||
          getReliableDateFromCheckoutUrl(params.get('checkout_url'));

        var validation = validateDeliveryDate({
          deliveryDate: currentDeliveryDate,
          region: region,
          postalCode: postalCode,
          now: new Date()
        });

        if (validation.isValid && !location.entered) {
          redirectToCheckout(params, { allowOriginal: true });
          return null;
        }

        return getZapietCalendar(locationId, postalCode).then(function (calendarData) {
          var zapietDates = getDatesFromZapietCalendar(calendarData);
          var zapietMinDate = calendarData && parseLocalDate(calendarData.minDate) ? calendarData.minDate : '';
          var nextAvailableDate = zapietMinDate || validation.nextAvailableDate;
          var availableDates = zapietDates.length ? zapietDates : getFallbackAvailableDates(region, new Date());

          if (availableDates.indexOf(nextAvailableDate) === -1) {
            availableDates.unshift(nextAvailableDate);
          }

          recoveryContext = {
            attrs: attrs,
            availableDates: availableDates,
            locationId: locationId,
            originalDeliveryDate: currentDeliveryDate || '',
            params: params,
            postalCode: postalCode,
            region: region,
            selectedDate: nextAvailableDate
          };

          return saveDeliveryDate(recoveryContext, nextAvailableDate).then(function () {
            pushDataLayer({
              event: 'abandoned_cart_delivery_date_corrected',
              original_delivery_date: currentDeliveryDate || '',
              new_delivery_date: nextAvailableDate
            });
            showConfirmation(ui, recoveryContext);
            bindConfirmationActions(ui, recoveryContext);
          });
        });
        });
      })
      .catch(function (err) {
        console.error('Recover cart error:', err);
        showRecoveryFailed(ui);
      });
  }

  window.InspiredGoRecoverCart = {
    getNextAvailableDeliveryDate: getNextAvailableDeliveryDate,
    validateDeliveryDate: validateDeliveryDate,
    recoverAbandonedCart: recoverAbandonedCart,
    getRecoveryContext: function () {
      return recoveryContext;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recoverAbandonedCart);
  } else {
    recoverAbandonedCart();
  }
})();
